export const paramId = ({ id }: { id?: string }) => id;
export const paramIds = ({ ids }: { ids: string[] }) => ids.join(',');
export const paramItemId = ({ itemId }: { itemId?: string }) => itemId;
